import Home from "./pages/Home";
import InstitutionPerformance from "./pages/InstitutionPerformance";
import GroupVisit from "./pages/GroupVisit";
import Venue from "./pages/Venue";
import GuideFieldTrip from "./pages/GuideFieldTrip";
import GuideFirstClassicAge from "./pages/GuideFirstClassicAge";
import About from "./pages/About";
import Inquiry from "./pages/Inquiry";
import Privacy from "./pages/Privacy";
import { routePaths } from "./data/routePaths";

export const routes = {
  "/": Home,
  "/institution-performance": InstitutionPerformance,
  "/group-visit": GroupVisit,
  "/venue": Venue,
  "/guide/field-trip-checklist": GuideFieldTrip,
  "/guide/first-classic-age": GuideFirstClassicAge,
  "/about": About,
  "/inquiry": Inquiry,
  "/privacy": Privacy,
};

// routePaths와 routes가 어긋나면 빈 페이지가 배포되므로 개발 중에 바로 알립니다.
if (import.meta.env?.DEV) {
  const missing = routePaths.filter((path) => !routes[path]);
  if (missing.length) console.error(`routes.jsx에 컴포넌트가 없는 경로: ${missing.join(", ")}`);
}
